import React, { useContext } from 'react';
import { Modal } from '../../../components/containers/Modal';
import { BeaconContext } from '../../../providers/BeaconProvider';

export type ViewPersonalDataModalViewProps = {
  closeModal: () => void;
};

export const ViewPersonalDataModalView = (props: ViewPersonalDataModalViewProps): JSX.Element => {
  const { beacon } = useContext(BeaconContext);

  const contactUsOnClick = () => {
    beacon('open');
    beacon('navigate', '/ask');
  };

  return (
    <Modal
      title={'Personal Data'}
      onClose={props.closeModal}
      size={'small'}
      closeOnClickOutside={false}
      closeOnEsc={true}
      primaryButtonAction={props.closeModal}
      primaryButtonTitle={'Ok'}
      primaryButtonDisabled={false}
      primaryButtonLoading={false}
      showCloseIcon={true}>
      <div className={'margin-bottom-small-20'}>
        Please <a onClick={contactUsOnClick}>contact us</a> if you wish to review what personal data you have provided.
        You may also request to have your personal data removed - NB this is not possible if you have an active paid
        subscription
      </div>
    </Modal>
  );
};
